<template>
  <main class="main-content">
    <section>
      <b-table
        v-if="headers"
        :data="headers"
        :checked-rows.sync="checkedRows">
        <template slot-scope="props">
          <b-table-column
            sortable
            field="title"
            label="Titel">
            {{ props.row.title }}
          </b-table-column>
          <b-table-column
            sortable
            centered
            :custom-sort="sortByStartDate"
            field="startdate"
            label="Start date">
            {{ props.row.startDate.toDate().toLocaleDateString() }}
          </b-table-column>
          <b-table-column
            sortable
            centered
            :custom-sort="sortByEndDate"
            field="enddate"
            label="End date">
            {{ props.row.endDate.toDate().toLocaleDateString() }}
          </b-table-column>
          <b-table-column
            field="image"
            label="Afbeelding"
            centered>
            <img
              class="table-image"
              :src="props.row.imageUrl"
              alt="">
          </b-table-column>
          <b-table-column
            field="image"
            label="Link"
            centered>
            <router-link :to="`/edit/header?id=${props.row.id}`">
              Bewerken
            </router-link>
          </b-table-column>
        </template>
      </b-table>
      <div v-else>
        <p>No headers found</p>
      </div>
    </section>
  </main>
</template>

<script>
import { db, firebase } from "../../firebase";

export default {
  name: "Headers",
  data() {
    return {
      headers: [],
      checkedRows: []
      // columns: [
      //   {
      //     field: "title",
      //     label: "Titel"
      //   },
      //   {
      //     field: "image",
      //     label: "Image"
      //   }
      // ]
    };
  },
  beforeCreate() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    sortByStartDate(a, b, isAsc) {
      if (isAsc) {
        return b.startDate.seconds - a.startDate.seconds;
      }
      return a.startDate.seconds - b.startDate.seconds;
    },
    sortByEndDate(a, b, isAsc) {
      if (isAsc) {
        return b.endDate.seconds - a.endDate.seconds;
      }
      return a.endDate.seconds - b.endDate.seconds;
    }
  },
  firestore: {
    headers: db.collection("headers")
  }
};
</script>

<style lang="scss">
.table-image {
  width: 70px;
}
.table td,
.checkbox-cell {
  vertical-align: middle;
}
</style>